import { z } from 'zod';
export const slugRegex = /^[a-z0-9](?:[a-z0-9-]{1,30}[a-z0-9])?$/;
export const profileSchema = z.object({
    id: z.string(),
    username: z.string(),
    slug: z.string(),
    displayName: z.string(),
    bio: z.string().nullable(),
    avatarUrl: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const friendProfileSchema = z.object({
    slug: z.string(),
    displayName: z.string(),
    avatarUrl: z.string().nullable(),
});
export const updateProfileSchema = z.object({
    slug: z
        .string()
        .trim()
        .toLowerCase()
        .regex(slugRegex, 'Slug must be 3-32 chars, lowercase letters, digits, hyphens')
        .optional(),
    displayName: z.string().trim().min(1).max(64).optional(),
    bio: z.string().trim().max(500).nullable().optional(),
    avatarUrl: z
        .preprocess((value) => (value === '' ? null : value), z
        .string()
        .refine((value) => value.startsWith('/uploads/avatar/') || z.string().url().safeParse(value).success, {
        message: 'Avatar must be a URL or an uploaded avatar path',
    })
        .nullable())
        .optional(),
});
//# sourceMappingURL=profile.schema.js.map